import classnames from "classnames";
import React from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { i18nSelectAction } from "../../../store/slices/common/i18n/i18nSelectAction";

const LanguageSelector = () => {
  const dispatch = useDispatch();
  const { languages, language } = useSelector((state) => state.i18n);

  const selectLanguage = (e, language) => {
    e.preventDefault();
    dispatch(i18nSelectAction(language));
  };

  if (!language) return <div />;

  return (
    <ul className="header-dropdown-list hidden-xs ng-cloak">
      <Dropdown as="li">
        <Dropdown.Toggle as="a" className={classnames("dropdown-toggle")}>
          <img src="/assets/img/blank.gif" className={classnames(["flag", "flag-" + language.key])} alt={language.alt} />
          <span style={{ marginTop: "0px" }}>&nbsp;{language.title}&nbsp;</span>
          <i className="fa fa-angle-down" />
        </Dropdown.Toggle>
        <Dropdown.Menu as="ul" className="dropdown-menu pull-right">
          {languages.map(
            (lang) =>
              lang.enable && (
                <Dropdown.Item as="li" key={lang.key} className={classnames({ active: lang.key === language.key })}>
                  <a href="/" onClick={(e) => selectLanguage(e, lang)} className="dropdown-item">
                    <img src="/assets/img/blank.gif" className={classnames(["flag", "flag-" + lang.key])} alt={lang.alt} />
                    <span>&nbsp;{lang.title}</span>
                  </a>
                </Dropdown.Item>
              )
          )}
        </Dropdown.Menu>
      </Dropdown>
    </ul>
  );
};

export default LanguageSelector;
